/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'percent': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18.5 3.5l-15 15 2 2 15-15M7 4a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3m10 10a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3z"/>'
  }
})
